import type { JSX, Ref } from 'preact';
import { ChatIcon, CloseIcon } from './icons';

interface LauncherProps {
  open: boolean;
  onToggle: () => void;
  buttonRef: Ref<HTMLButtonElement>;
}

export function Launcher({ open, onToggle, buttonRef }: LauncherProps): JSX.Element {
  return (
    <button
      ref={buttonRef}
      type="button"
      class="sa-launcher"
      onClick={onToggle}
      aria-expanded={open}
      aria-label={open ? 'إغلاق مساعد الكتب' : 'افتح مساعد الكتب'}
    >
      {open ? <CloseIcon /> : <ChatIcon />}
    </button>
  );
}
